module.exports = __webpack_public_path__ + "static/img/KE.5a144771.jpg";